<template>
    <div class="progress-cnt">
        <div class="progress-content">
            <button v-for="(item, index) in pages" :key="index" class="relative w-[64px] opacity-50" :class="index < current ? 'div-selected' : ''" 
            :disabled="index >= current - 1" @click="$router.push(item?.url)">
                <div v-if="index > 0" class="hidden sm:block absolute top-[20px] left-[-52px] w-[38px] h-[2px] bg-[#e96932]"></div>
                <span class="w-[40px] h-[40px] bg-[#fff] border border-[#e96932] block rounded-[50%] mb-[5px] mx-auto" :class="index < current - 1 ? 'selected' : ''"></span>
                <h6 class="text-center">{{ item.name }}</h6>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BreadcrumbList',
    components: {  },
    props: {
        current: Number
    },

    data() {
        return {
            pages: [
                { id: 0, name: "Home", url: "/" },
                { id: 1, name: "Veicolo", url: "/scelta-veicolo" },
                { id: 2, name: "Ricerca", url: "/ricerca-modello" },
                { id: 3, name: "Valutazione", url: "" }
            ],
        }
    },

    methods: {
    }
}
</script>

<style scoped>
.progress-cnt {
    display: inline-block;
    width: 100%;
    border-top: 1px solid #e96932;
    border-bottom: 1px solid #e96932;
    margin: 30px 0;
    padding: 20px;
}
.progress-content {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
}
.selected {
    background-image: url("../../public/icon/selected.png");
    background-position: 50%;
    background-repeat: no-repeat;
}
.div-selected {
    opacity: 1 !important;
}
@media (max-width: 639px) {
    .progress-cnt {
        margin: 15px 0;
        padding: 10px;
    }
    .progress-content {
        width: 100%;
    }
}
</style>